/**
 * Given an object and a display field, returns a version that can be displayed as a string
 * appropriately instead of showing `[object Object]`.
 */
const displayable = <T>(value: T, field: keyof T) =>
  value && { ...value, toString: () => value?.[field] };

export default displayable;
